import axios from 'axios'

import errorHandler from './error-handler'

export default {
  all () {
    return axios.get('/api/companies').then(r => r.data).catch(errorHandler)
  },
  current () {
    return axios.get('/api/companies/current').then(r => r.data)
  },
  create ({ image, name, domain, category, companyJobsBoard, bio }) {
    const formData = new FormData()
    formData.append('image', image)
    formData.append('name', name)
    formData.append('domain', domain)
    formData.append('category', category)
    formData.append('companyJobsBoard', companyJobsBoard)
    formData.append('bio', bio)
    return axios.post('/api/companies', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(r => r.data).catch(errorHandler)
  },
  update (companyId, { image, name, domain, category, companyJobsBoard, bio }) {
    const formData = new FormData()
    formData.append('name', name)
    formData.append('domain', domain)
    formData.append('category', category)
    formData.append('companyJobsBoard', companyJobsBoard)
    formData.append('bio', bio)
    if (image) { formData.append('image', image) }
    return axios.put(`/api/companies/${companyId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(r => r.data).catch(errorHandler)
  },
  getDetail (companyId) {
    return axios.get(`/api/companies/${companyId}`).then(r => r.data).catch(errorHandler)
  },
  getStats (companyId) {
    return axios.get(`/api/companies/${companyId}/stats`).then(r => r.data).catch(errorHandler)
  },
  getSocialProfiles (companyId) {
    return axios.get(`/api/companies/${companyId}/profiles`).then(r => r.data).catch(errorHandler)
  },
  async inviteCompany (jobBoardId, email) {
    return axios.post(`/api/job_board/${jobBoardId}/inviteByEmail`, {email}).then(r => r.data).catch(errorHandler)
  },
  async getActiveCompanies (id) {
    return axios.get(`/api/job_board/${id}/companies?status=active`).then(r => r.data).catch(errorHandler)
  },
  async getRequestedCompanies (id) {
    return axios.get(`/api/job_board/${id}/companies?status=requested`).then(r => r.data).catch(errorHandler)
  },
  async companyAction (data, indicator) {
    return axios.post(`/api/companiesToJobBoard/${indicator}`, data).then(r => r.data).catch(errorHandler)
  },
  async toggleCompany (data) {
    return axios.post('/api/companiesToJobBoard/put-on-hold-company', data).then(r => r.data).catch(errorHandler)
  },
  async getCompanies (filters) {
    return axios.post('/api/companies/search', {...filters}).then(r => r.data).catch(errorHandler)
  },
  async getCompanyCategories () {
    return axios.get('/api/domain/categories').then(r => r.data).catch(errorHandler)
  }
}



// WEBPACK FOOTER //
// ./src/api/companies.js